import { ApiEndpoints, Organ } from 'models'
import { apiGet } from 'services/api'

export async function getAllOrgans(): Promise<{ status: number; body?: Organ[] }> {
  return apiGet(ApiEndpoints.getAllOrgans)
    .then((response) => {
      return { status: response.status, body: response?.body }
    })
    .catch((err) => {
      throw err
    })
}

export async function getLlistatOrgans(urlParams: {
  pagination: object
  filtre: object
}): Promise<{ status: number; organs?: Array<Organ>; totalOrgans: number; totalPages: number }> {
  const params = Object.values(urlParams.filtre).every((value) => !value)
    ? { pagination: urlParams.pagination }
    : urlParams

  return apiGet(ApiEndpoints.getOrgansList, params)
    .then((response) => {
      return { status: response.status, ...response.body }
    })
    .catch((err) => {
      throw err
    })
}
